var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.72 0H1.04C0.465918 0 0 0.465918 0 1.04V18.72C0 19.2941 0.465918 19.76 1.04 19.76H18.72C19.2941 19.76 19.76 19.2941 19.76 18.72V1.04C19.76 0.465918 19.2941 0 18.72 0ZM17.68 17.68H2.08V2.08H17.68V17.68V17.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9198 21.32V23.92H21.3198V26H24.9598C25.5339 26 25.9998 25.5341 25.9998 24.96V21.32H23.9198Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9179 23.92H13.3228V26H18.9179V23.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31974 23.92V21.32H6.23975V24.96C6.23975 25.5341 6.70566 26 7.27974 26H10.9197V23.92H8.31974Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9598 6.24002H21.3198V8.32002H23.9198V10.92H25.9998V7.28002C25.9998 6.70594 25.5339 6.24002 24.9598 6.24002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 13.3224H23.9199V18.9176H26V13.3224Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.68b1515920f69cb271b6148fba23a7bb.svg";
export { ForwardRef as ReactComponent };